(function () {
  'use strict';

  var MAX_PREFETCH = 5;
  var HOVER_DELAY_MS = 150;

  var BLOCKED = [
    '/cart',
    '/checkout',
    '/checkouts',
    '/account',
    '/challenge',
    '/password',
    '/search',
    '/services/login_with_shop'
  ];

  function connectionIsSlow() {
    var c = navigator.connection;
    if (!c) return false;

    if (c.saveData === true) return true;

    if (c.effectiveType && ['slow-2g', '2g', '3g'].indexOf(c.effectiveType) !== -1) {
      return true;
    }

    // 4G nominal mas com banda baixa ainda é rede ruim na prática.
    if (typeof c.downlink === 'number' && c.downlink < 3) return true;

    return false;
  }

  function isDesktopPointer() {
    return window.matchMedia && window.matchMedia('(pointer: fine)').matches;
  }

  function shouldPrefetch(link) {
    if (!link || !link.href) return false;
    if (link.target === '_blank') return false;
    if (link.hasAttribute('download')) return false;

    var href = link.href;
    if (href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return false;

    var url;
    try {
      url = new URL(href);
    } catch (e) {
      return false;
    }

    if (url.hostname !== window.location.hostname) return false;
    if (url.pathname === window.location.pathname) return false;

    for (var i = 0; i < BLOCKED.length; i++) {
      if (url.pathname.indexOf(BLOCKED[i]) === 0) return false;
    }

    return true;
  }

  function initIntentPrefetch() {
    if (connectionIsSlow()) return;
    if (!isDesktopPointer()) return;

    var done = new Set();
    var timer = null;

    function prefetch(link) {
      if (done.size >= MAX_PREFETCH) return;
      if (!shouldPrefetch(link)) return;

      var href = link.href.split('#')[0];
      if (done.has(href)) return;

      // Reavalia a rede a cada prefetch: a conexão pode ter piorado.
      if (connectionIsSlow()) return;

      done.add(href);

      var hint = document.createElement('link');
      hint.rel = 'prefetch';
      hint.href = href;
      hint.as = 'document';
      document.head.appendChild(hint);
    }

    function schedule(event) {
      var link = event.target && event.target.closest && event.target.closest('a');
      if (!link) return;

      clearTimeout(timer);
      timer = setTimeout(function () {
        prefetch(link);
      }, HOVER_DELAY_MS);
    }

    function cancel() {
      clearTimeout(timer);
    }

    document.addEventListener('pointerover', schedule, { passive: true });
    document.addEventListener('focusin', schedule, { passive: true });
    document.addEventListener('pointerout', cancel, { passive: true });
  }

  function afterLoad(callback) {
    function run() {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(callback, { timeout: 3000 });
      } else {
        setTimeout(callback, 2000);
      }
    }

    if (document.readyState === 'complete') {
      run();
    } else {
      window.addEventListener('load', run, { once: true });
    }
  }

  afterLoad(initIntentPrefetch);
})();